import { HomePage } from '../../../pageComponents/home-page';

export { getStaticProps } from '../../../pageComponents/home-page';

export default HomePage;
